var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "md-ripple",
    {
      attrs: {
        "md-disabled": !_vm.mdRipple || _vm.disabled,
        "md-event-trigger": false,
        "md-active": _vm.mdRippleActive,
      },
      on: {
        "update:mdActive": (active) =>
          _vm.$emit("update:mdRippleActive", active),
      },
    },
    [_c("div", { staticClass: "md-button-content" }, [_vm._t("default")], 2)]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }